<mat-dialog-content>
  <ng-container *ngIf="!isLoading(); else loader">
    <mat-table *ngIf="dataSource?.length" [dataSource]="dataSource" aria-label="Elements">
      <ng-container matColumnDef="checkboxes">
        <mat-header-cell *matHeaderCellDef style="flex: 2">
          {{ 'POPUPS.INCLUDED_DIAGRAMS_LABEL' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex: 2" class="authorisable-icon">
          <mat-icon
            class="without-stroke-width"
            [svgIcon]="row | getAuthorisableIcon: override"
            [ngClass]="row | getAuthorisableIcon: override"></mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="level">
        <mat-header-cell *matHeaderCellDef style="flex: 2">
          {{ 'TOOLBAR.LEVEL' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex: 2">
          <span>{{ row.levelNumber }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="diagram">
        <mat-header-cell *matHeaderCellDef style="flex: 5">
          {{ 'POPUPS.NAME_LABEL' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex: 5">
          <span
            *q9Screenshot="row | getScreenshotConfig"
            [innerHTML]="row.name | htmlEncoder: true"
            [matTooltip]="row.name | decodeHtml"
            matTooltipShowDelay="400"
            matTooltipHideDelay="400"
            matTooltipPosition="above"
            appTooltipOnOverflow
            #name="isDisabledTooltip"
            [matTooltipDisabled]="name.isDisabledTooltip"></span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="state">
        <mat-header-cell *matHeaderCellDef style="flex: 6">
          {{ 'POPUPS.REASON_LABEL' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let row" style="flex: 6">
          <span
            #state="isDisabledTooltip"
            [matTooltip]="row | getDiagramStateLabel: override"
            matTooltipShowDelay="400"
            matTooltipHideDelay="400"
            matTooltipPosition="above"
            appTooltipOnOverflow
            [matTooltipDisabled]="state.isDisabledTooltip">
            {{ row | getDiagramStateLabel: override }}
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <div *ngIf="!dataSource?.length" class="empty-state">
      <img [src]="noItemsImage" [alt]="'SEARCH.NO_MATCHING_ITEMS' | translate" />
      <span>{{ 'SEARCH.NO_MATCHING_ITEMS' | translate }}</span>
    </div>
  </ng-container>
  <ng-template #loader>
    <q9-content-loader [isLoading]="true"></q9-content-loader>
  </ng-template>
</mat-dialog-content>

<mat-paginator
  #paginator
  color="primary"
  [length]="diagramList?.length"
  [pageSize]="pageSize"
  [hidePageSize]="false"
  [hidden]="isLoading() || !dataSource?.length"
  (page)="updateDataSource()"></mat-paginator>

<mat-dialog-actions>
  <q9-secondary-button (click)="backToSubmission.emit()">
    {{ 'VERSIONING.BACK_FROM_LOWER_LEVELS_LABEL' | translate }}
  </q9-secondary-button>
</mat-dialog-actions>
